export default __webpack_public_path__ + "static/media/1443.f9f98a72.png";